import App from './App';
// import * as dat from 'dat.gui';
import React, {useState } from 'react'
import {useLayoutEffect } from 'react'
import * as dat from 'dat.gui';


export default function AppData() {

    // GUI for data
    //Original : const [data, setData]
    const [data, setData] = useState({ 

        backgroundColor: '#001429',
        lightColor: '#ec6f6f',
        lightGroundColor: '#282557',
        lightIntensity: 1.41,
        lightPosX: 0.18,
        lightPosY: 1.07,
        lightPosZ: 0.81,
        pointColor: '#e8cc4b',
        pointIntensity: 2.1,
        pointDistance: 0.46,
        pointX: 0.01,
        pointY: 0.25,
        pointZ: -0.9,
        fogColor: '#282d41',
        fogNear: 0.013,
        fogFar: 3.3,

        stdMatColor: '#ffffff',
        roughness: 0.71,
        metalness: 0.51,
    });



    const updateField = (key, value) => {

        setData(prevState => ({
            ...prevState,
            [key]: value
        }));

    };

 

    useLayoutEffect(() => {
        
   
        var datGui = new dat.GUI()
        var env = datGui.addFolder("env")
        var hemiLight = env.addFolder("hemi light")
        var pointLight = env.addFolder("point light")
        var fog = env.addFolder("fog")
        var mat = datGui.addFolder("mat")
      

        var allData = []

        allData.push(

            hemiLight.addColor(data, 'lightColor'),
            hemiLight.addColor(data, 'lightGroundColor'),
            hemiLight.add(data, 'lightIntensity'),
            hemiLight.add(data, 'lightPosX'),
            hemiLight.add(data, 'lightPosY'),
            hemiLight.add(data, 'lightPosZ'),
            pointLight.addColor(data, 'pointColor'),
            pointLight.add(data, 'pointIntensity'),
            pointLight.add(data, 'pointDistance'),
            pointLight.add(data, 'pointX'),
            pointLight.add(data, 'pointY'),
            pointLight.add(data, 'pointZ'),
            fog.addColor(data, 'fogColor'),
            fog.add(data, 'fogNear'),
            fog.add(data, 'fogFar'),

            mat.addColor(data, 'stdMatColor'),
            mat.add(data, 'roughness'),
            mat.add(data, 'metalness'),

            env.addColor(data,'backgroundColor' ),

        )

        allData.forEach((element) => { 
            
            element.onChange(function (value) {
    
                updateField(element.property, value)
    
            });

        } )

      
        
    }, [])// eslint-disable-line react-hooks/exhaustive-deps
  


    return(

        <App 

            data = {data}
        
        />

    )
}